import React from 'react';
import { Avatar } from 'antd';
import { isValidElement } from 'react';

const IconChip = ({ icon, label, onClick, className = '', avatarClassName = '',
                  size=28, shape='circle', bordered=true,
                  px='px-3', py='py-1'}) => {
  // Check if icon is a URL string
  const isIconUrl = typeof icon === 'string' && (icon.startsWith('http') || icon.startsWith('/'));

  return (
    <button
      onClick={onClick}
      className={`
        inline-flex items-center gap-2 
        ${px} ${py}
        bg-transparent hover:bg-gray-50
        rounded-full
        transition-colors duration-200
        cursor-pointer
        ${className}
        ${bordered && "border border-gray-200"}
      `}
    >
        {icon && (
            <Avatar
                size={size}
                shape={shape}
                src={isIconUrl ? icon : undefined}
                icon={!isIconUrl ? icon : undefined}
                className={`${avatarClassName}`}
              />
        )}
      <span className="text-sm font-normal text-gray-700">
        {label}
      </span>
    </button>
  );
};



export default IconChip;